module.exports = __webpack_public_path__ + "static/img/bg.d71cf172.jpg";